import { Component } from '@angular/core';

/**
 * Component for quoter layout
 * @export
 * @class TempMainLayoutComponent
 */
@Component({
  selector: 'temp-main-layout',
  templateUrl: './temp-main-layout.component.html',
  styleUrls: ['./temp-main-layout.component.scss'],
})
export class TempMainLayoutComponent {}
